export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  cover: string;
  description: string;
  status: '连载中' | '已完结';
  chapters: number;
  updateDate: string;
  rating: number;
  views: number;
  tags: string[];
  content?: string;
  chapterList?: Chapter[];
}

export interface Chapter {
  id: string;
  title: string;
  number: number;
  date: string;
}

export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  count: number;
  image: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '日系h漫画',
    slug: 'japanese',
    icon: 'ri-sun-line',
    count: 1280,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20with%20romantic%20atmosphere%2C%20cherry%20blossom%20petals%2C%20soft%20pink%20and%20warm%20lighting%2C%20artistic%20anime%20aesthetic%2C%20elegant%20composition%2C%20clean%20background%20with%20subtle%20gradient&width=800&height=500&seq=cat-japanese-001&orientation=landscape',
    description: '汇集最新最全的日系成人漫画，从经典作品到热门新作，应有尽有。'
  },
  {
    id: 'cat-2',
    name: '国产h漫画',
    slug: 'chinese',
    icon: 'ri-china-railway-line',
    count: 860,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20art%20style%20illustration%2C%20elegant%20traditional%20and%20modern%20fusion%2C%20warm%20golden%20lighting%2C%20ink%20wash%20painting%20influence%2C%20romantic%20mood%2C%20refined%20composition%2C%20soft%20atmospheric%20background&width=800&height=500&seq=cat-chinese-001&orientation=landscape',
    description: '精选国内优秀成人漫画作品，支持原创国漫作者，品质保证。'
  },
  {
    id: 'cat-3',
    name: '韩国h漫画',
    slug: 'korean',
    icon: 'ri-smartphone-line',
    count: 720,
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20art%20illustration%2C%20modern%20urban%20romance%20atmosphere%2C%20clean%20lines%2C%20sophisticated%20color%20palette%2C%20digital%20art%20aesthetic%2C%20warm%20ambient%20lighting%2C%20elegant%20minimalist%20composition&width=800&height=500&seq=cat-korean-001&orientation=landscape',
    description: '韩国条漫风格成人漫画，画风精致细腻，剧情引人入胜。'
  },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '午夜樱花',
    author: '山田太郎',
    category: '日系h漫画',
    categorySlug: 'japanese',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20style%2C%20romantic%20couple%20silhouette%20under%20cherry%20blossom%20tree%20at%20night%2C%20soft%20moonlight%2C%20pink%20petals%20falling%2C%20elegant%20anime%20illustration%2C%20clean%20composition%20with%20warm%20atmosphere&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '在樱花纷飞的夜晚，两个灵魂的相遇改变了彼此的命运。一段禁忌而深刻的爱恋在月光下悄然绽放。',
    status: '连载中',
    chapters: 48,
    updateDate: '2026-08-06',
    rating: 4.8,
    views: 152000,
    tags: ['恋爱', '校园', '治愈'],
    chapterList: [
      { id: 'ch-1-1', title: '第1话 樱花树下的相遇', number: 1, date: '2025-03-15' },
      { id: 'ch-1-2', title: '第2话 月光下的约定', number: 2, date: '2025-03-22' },
      { id: 'ch-1-3', title: '第3话 不期而遇的心动', number: 3, date: '2025-03-29' },
    ],
    content: '<p>在樱花纷飞的夜晚，两个灵魂的相遇改变了彼此的命运...</p>',
  },
  {
    id: 'comic-2',
    title: '禁忌之恋',
    author: '佐藤花子',
    category: '日系h漫画',
    categorySlug: 'japanese',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%2C%20intimate%20romantic%20scene%2C%20two%20figures%20close%20together%2C%20warm%20amber%20lighting%2C%20soft%20shadows%2C%20elegant%20anime%20style%20illustration%2C%20emotional%20atmosphere&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '她是他不能爱的人，他却是她唯一的救赎。一段跨越禁忌的恋情在秘密中悄然生长。',
    status: '已完结',
    chapters: 72,
    updateDate: '2026-07-28',
    rating: 4.9,
    views: 238000,
    tags: ['恋爱', '职场', '剧情'],
    chapterList: [
      { id: 'ch-2-1', title: '第1话 初遇', number: 1, date: '2025-01-10' },
      { id: 'ch-2-2', title: '第2话 心动', number: 2, date: '2025-01-17' },
      { id: 'ch-2-3', title: '第3话 秘密', number: 3, date: '2025-01-24' },
    ],
  },
  {
    id: 'comic-3',
    title: '暗夜情愫',
    author: '李明华',
    category: '国产h漫画',
    categorySlug: 'chinese',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%2C%20romantic%20night%20scene%20in%20modern%20city%2C%20couple%20embracing%2C%20neon%20lights%20reflection%2C%20elegant%20digital%20illustration%2C%20warm%20moody%20atmosphere&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '都市的霓虹灯下，一场意外的相遇让她卷入了一段危险而迷人的关系。',
    status: '连载中',
    chapters: 36,
    updateDate: '2026-08-05',
    rating: 4.7,
    views: 98000,
    tags: ['都市', '悬疑', '爱情'],
    chapterList: [
      { id: 'ch-3-1', title: '第1话 霓虹下的邂逅', number: 1, date: '2025-06-20' },
      { id: 'ch-3-2', title: '第2话 危险的诱惑', number: 2, date: '2025-06-27' },
      { id: 'ch-3-3', title: '第3话 不可告人的秘密', number: 3, date: '2025-07-04' },
    ],
  },
  {
    id: 'comic-4',
    title: '深情告白',
    author: '王雨晴',
    category: '国产h漫画',
    categorySlug: 'chinese',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20art%2C%20romantic%20confession%20scene%2C%20garden%20setting%20with%20flowers%2C%20soft%20natural%20light%2C%20elegant%20character%20designs%2C%20warm%20color%20palette%2C%20dreamy%20atmosphere&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '十年暗恋，一朝告白。当初那个不起眼的少年，如今成了她无法忽视的存在。',
    status: '连载中',
    chapters: 24,
    updateDate: '2026-08-04',
    rating: 4.6,
    views: 76000,
    tags: ['恋爱', '青春', '职场'],
  },
  {
    id: 'comic-5',
    title: '首尔之夜',
    author: '朴智恩',
    category: '韩国h漫画',
    categorySlug: 'korean',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20style%2C%20romantic%20night%20scene%20in%20Seoul%2C%20couple%20walking%20along%20Han%20River%2C%20city%20lights%2C%20clean%20digital%20art%2C%20elegant%20modern%20romance%20atmosphere&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '首尔的夜晚，繁华与孤独交织。当两个寂寞的灵魂在汉江边相遇，一切都变得不同了。',
    status: '连载中',
    chapters: 56,
    updateDate: '2026-08-07',
    rating: 4.8,
    views: 185000,
    tags: ['都市', '恋爱', '剧情'],
  },
  {
    id: 'comic-6',
    title: '甜蜜陷阱',
    author: '金秀贤',
    category: '韩国h漫画',
    categorySlug: 'korean',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20art%2C%20romantic%20suspense%20theme%2C%20elegant%20couple%20in%20luxury%20setting%2C%20warm%20golden%20lighting%2C%20sophisticated%20illustration%2C%20mysterious%20yet%20romantic%20mood&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '她说这是爱情，他说这是交易。当甜蜜的背后藏着不可告人的秘密，谁才是真正的猎物？',
    status: '已完结',
    chapters: 64,
    updateDate: '2026-07-15',
    rating: 4.5,
    views: 142000,
    tags: ['悬疑', '爱情', '职场'],
  },
  {
    id: 'comic-7',
    title: '樱色幻想',
    author: '藤原健太',
    category: '日系h漫画',
    categorySlug: 'japanese',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20cover%20illustration%2C%20dreamy%20fantasy%20romance%2C%20magical%20glowing%20elements%2C%20cherry%20blossoms%2C%20soft%20pastel%20colors%2C%20elegant%20anime%20art%20style%2C%20ethereal%20atmosphere&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '在那个樱色弥漫的梦境中，她遇见了不该遇见的人，也爱上了不该爱的灵魂。',
    status: '连载中',
    chapters: 32,
    updateDate: '2026-08-03',
    rating: 4.7,
    views: 108000,
    tags: ['奇幻', '恋爱', '治愈'],
  },
  {
    id: 'comic-8',
    title: '都市纠缠',
    author: '陈思远',
    category: '国产h漫画',
    categorySlug: 'chinese',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%2C%20urban%20romance%20drama%2C%20office%20setting%20with%20romantic%20tension%2C%20modern%20sophisticated%20style%2C%20warm%20moody%20lighting%2C%20elegant%20character%20portraits&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '办公室里，他是她的上司，她是他的下属。一段不该发生的感情在职场中暗流涌动。',
    status: '连载中',
    chapters: 40,
    updateDate: '2026-08-06',
    rating: 4.6,
    views: 89000,
    tags: ['职场', '恋爱', '都市'],
  },
];

export const hotComics = comics.slice(0, 6);
export const latestComics = [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime());

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter(c => c.categorySlug === slug);
}

export function getComicById(id: string): Comic | undefined {
  return comics.find(c => c.id === id);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find(c => c.slug === slug);
}